import { z } from "@/utils/form";
import { createFileRoute } from "@tanstack/react-router";

import { commonComponents as cc } from "@/components/common";
import AuthWrap from "@/features/auth/components/AuthWrap";
import LoginForm from "@/features/auth/components/LoginForm";

const Login = () => {
	const { email } = Route.useSearch();

	return (
		<AuthWrap>
			<cc.Title words="Sign in" />
			<LoginForm email={email} />
		</AuthWrap>
	);
};

const loginSchemaZ = z.object({
	email: z.string().optional(),
});

export const Route = createFileRoute("/_auth/login")({
	component: Login,
	validateSearch: (search) => loginSchemaZ.parse(search),
});
